import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { api, setAdminToken } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { password });
      setAdminToken(data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] bg-stone-950 flex items-center justify-center px-6 py-16" data-testid="admin-login-page">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md border border-stone-800 bg-stone-900 p-10"
      >
        <Lock className="h-8 w-8 text-yellow-400" />
        <h1 className="mt-6 font-display text-3xl font-bold text-stone-50">
          Admin Access
        </h1>
        <p className="mt-2 text-stone-400 text-sm">
          Owner-only area. Enter the admin password.
        </p>
        <div className="mt-6 space-y-2">
          <Label className="text-xs uppercase tracking-[0.2em] font-bold text-stone-300">
            Password
          </Label>
          <Input
            type="password"
            data-testid="admin-login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bg-stone-950 border-stone-700 focus:border-yellow-500 rounded-none h-11"
          />
        </div>
        <Button
          type="submit"
          disabled={loading || !password}
          data-testid="admin-login-submit"
          className="mt-6 w-full bg-yellow-500 text-yellow-950 hover:bg-yellow-400 font-bold uppercase tracking-wider rounded-none h-11 border-2 border-yellow-500"
        >
          {loading ? "Checking..." : "Sign In"}
        </Button>
      </form>
    </div>
  );
}
